import { render } from "./DetailFilePage.vue?vue&type=template&id=54b1d899&ts=true"
import script from "./DetailFilePage.vue?vue&type=script&lang=ts"
export * from "./DetailFilePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__